var exports = {
  "ag": "x93eb46d8--90b7ee--balloon",
  "m3": "x93eb46d8--90b7ee--multi",
  "lq": "x93eb46d8--90b7ee--viewed",
  "vu": "x93eb46d8--90b7ee--active",
  "q9": "x93eb46d8--90b7ee--price",
};

module.exports = exports;
